import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LanguageCode } from "../../utils/translations";
import { HOME_COPY } from "../home/homeContent";
import { HOME_THEME } from "../home/theme";

interface EndToEndBandProps {
  lang: LanguageCode;
}

const EndToEndBand: React.FC<EndToEndBandProps> = ({ lang }) => {
  const { lead, chips, seeAll } = HOME_COPY[lang].band;

  return (
    <section
      style={{
        padding: "26px 5%",
        background: HOME_THEME.surfaceAlt,
        borderTop: `1px solid ${HOME_THEME.border}`,
        borderBottom: `1px solid ${HOME_THEME.border}`,
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px 16px",
          flexWrap: "wrap",
          textAlign: "center",
        }}
      >
        <span
          style={{
            fontWeight: 800,
            color: HOME_THEME.heroHeading,
            fontSize: "0.95rem",
          }}
        >
          {lead}
        </span>

        <div
          style={{
            display: "flex",
            gap: "8px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {chips.map((chip) => (
            <Link
              key={chip.to}
              to={chip.to}
              style={{
                textDecoration: "none",
                fontSize: "0.82rem",
                fontWeight: 600,
                color: HOME_THEME.primaryDark,
                background: HOME_THEME.surface,
                border: `1px solid ${HOME_THEME.border}`,
                borderRadius: "999px",
                padding: "6px 12px",
                whiteSpace: "nowrap",
              }}
            >
              {chip.label}
            </Link>
          ))}
        </div>

        <Link
          to="/services"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            textDecoration: "none",
            fontWeight: 800,
            fontSize: "0.85rem",
            color: HOME_THEME.primary,
          }}
        >
          {seeAll} <ArrowRight size={15} />
        </Link>
      </div>
    </section>
  );
};

export default EndToEndBand;
